import axios from "@/plugins/axios";

let url = "/api/console/cashes";

export default {
    gets(data){
        return axios.get(url, data).then(result => result.data);
    },
    cancel(data){
        return axios.post(`${url}/cancel`, data).then(result => result.data);
    }
}
